/*** Directory for static string constants ***/

import * as actionTypes from './action-types';
import * as loanTypes from './loan-types';
import * as clientTypes from './client-types';
import * as servicingTypes from './servicing-types';
import {patterns} from './patterns';

const constants = {
    actionTypes,
    loanTypes,
    clientTypes,
    patterns,
    servicingTypes,
};

export default constants;